import React, { useState, useEffect, useMemo } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Checkbox,
} from "@mui/material";
import { View, StyleSheet } from "react-native";
import AppScreenBackground from "../components/Common/ComponentAppBackground.jsx";
import { useSelector } from "react-redux";
import { InfoComponent, ImageComponent } from "../components/FullComponent.js";
import {
  updateConfirmedStone,
  getStatusFornitureDelivery,
} from "../services/ConnectDataBase";
import { translateText } from "../translations/translationService";
import { FORNITURE_DELIVERY_SCREEN_COLORS } from "../style/colors.js";

export default function FornitureDeliveryScreen({ route }) {
  const [isFirstConfirmed, setIsFirstConfirmed] = useState(false);
  const [isSecondConfirmed, setIsSecondConfirmed] = useState(false);
  const [checkedItems, setCheckedItems] = useState({});
  const lang = useSelector((state) => state.lang.value);
  const infoData = useSelector((state) => state.infoData.infoData);
  const { eFabrica, ...data } = infoData;
  const codeScan = infoData.MO;
  const PO = infoData.PO;
  const name = useSelector((state) => state.user.name);
  const confirmed = "CONFIRMED";
  let status = "fornitureStatus";
  let codePage = 10;
  let ConfirmedFirstTeam = "FORNITURE";
  let ConfirmedSecondTeam = "TALLERFORNITURE";
  const screenName = "FornitureDeliveryScreen";

  const newArray = useMemo(() => {
    return eFabrica
      .filter(({ tipo }) => tipo === "FORNITURAS")
      .map(({ codigo, quilates, peso, numeropiedras }) => ({
        codigo,
        quilates: formatNumber(quilates),
        peso: formatNumber(peso),
        numeropiedras: numeropiedras ? Number(numeropiedras).toFixed(2) : "-",
      }));
  }, [eFabrica]);

  useEffect(() => {
    initializeCheckedItems();
  }, [eFabrica]);

  useEffect(() => {
    if (codeScan && PO) {
      getStatusForDelivery();
    }
  }, [codeScan, PO]);

  function formatNumber(value) {
    const number = parseFloat(value);
    return Math.abs(number) < 1 && !Number.isInteger(number)
      ? number.toString().startsWith("0")
        ? number.toString()
        : `0${number}`
      : number.toString();
  }

  async function getStatusForDelivery() {
    try {
      const statusDelivery = await getStatusFornitureDelivery(
        codeScan,
        codePage,
        status,
        PO
      );
      if (
        statusDelivery[0]?.usuario_ok_fornituras &&
        statusDelivery[0]?.fecha_ok_fornituras
      ) {
        setIsFirstConfirmed(true);
      }
      if (
        statusDelivery[0]?.usuario_ok_fornituras_taller &&
        statusDelivery[0]?.fecha_ok_fornituras_taller
      ) {
        setIsSecondConfirmed(true);
      }
    } catch (error) {
      console.error(error);
    }
  }

  function initializeCheckedItems() {
    if (Object.keys(checkedItems).length === 0) {
      const initialCheckedItems = newArray.reduce((acc, item) => {
        acc[item.codigo] = { checkPiedras: false, checkTaller: false };
        return acc;
      }, {});
      setCheckedItems(initialCheckedItems);
    }
  }

  const handleConfirm = (action, codigo) => {
    setCheckedItems((prev) => ({
      ...prev,
      [codigo]: {
        ...prev[codigo],
        [action === "first" ? "checkPiedras" : "checkTaller"]: true,
      },
    }));

    let tzoffset = new Date().getTimezoneOffset() * 60000;
    let localISOTime = new Date(Date.now() - tzoffset)
      .toISOString()
      .slice(0, -1);

    if (action === "first" && !isFirstConfirmed) {
      setIsFirstConfirmed(true);
      updateConfirmedStone(
        codeScan,
        codePage,
        ConfirmedFirstTeam,
        name,
        localISOTime,
        confirmed,
        PO,
        screenName
      );
    } else if (action === "second" && !isSecondConfirmed) {
      setIsSecondConfirmed(true);
      updateConfirmedStone(
        codeScan,
        codePage,
        ConfirmedSecondTeam,
        name,
        localISOTime,
        confirmed,
        PO,
        screenName
      );
    }
  };

  const TableComponent = () => (
    <TableContainer
      component={Paper}
                  sx={{ maxHeight: 400, backgroundColor: FORNITURE_DELIVERY_SCREEN_COLORS.BACKGROUND_TABLE_CONTAINER }}>
      <Table stickyHeader size='small'>
        <TableHead>
                        <TableRow sx={{ backgroundColor: FORNITURE_DELIVERY_SCREEN_COLORS.BACKGROUND_TABLE_HEADER }}>
            <TableCell
              align='center'
              sx={{ color: "black", fontWeight: "bold" }}>
              {translateText("Código", lang)}
            </TableCell>
            <TableCell
              align='center'
              sx={{ color: "black", fontWeight: "bold" }}>
              {translateText("Quilates", lang)}
            </TableCell>
            <TableCell
              align='center'
              sx={{ color: "black", fontWeight: "bold" }}>
              {translateText("AVG", lang)}
            </TableCell>
            <TableCell
              align='center'
              sx={{ color: "black", fontWeight: "bold" }}>
              {translateText("Nº Piedras", lang)}
            </TableCell>
            <TableCell
              align='center'
              sx={{ color: "black", fontWeight: "bold" }}>
              {translateText("Check Fornituras", lang)}
            </TableCell>
            <TableCell
              align='center'
              sx={{ color: "black", fontWeight: "bold" }}>
              {translateText("Check taller", lang)}
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {newArray.map((item, index) => (
            <TableRow key={index}>
              <TableCell align='center' sx={{ color: "white" }}>
                {item.codigo}
              </TableCell>
              <TableCell align='center' sx={{ color: "white" }}>
                {item.quilates}
              </TableCell>
              <TableCell align='center' sx={{ color: "white" }}>
                {item.peso}
              </TableCell>
              <TableCell align='center' sx={{ color: "white" }}>
                {item.numeropiedras}
              </TableCell>
              <TableCell align='center'>
                <Checkbox
                  checked={
                    checkedItems[item.codigo]?.checkPiedras || isFirstConfirmed
                  }
                  onChange={() => handleConfirm("first", item.codigo)}
                  disabled={isFirstConfirmed}
                  sx={{ color: isFirstConfirmed ? "grey" : "white" }}
                />
              </TableCell>
              <TableCell align='center'>
                <Checkbox
                  checked={
                    checkedItems[item.codigo]?.checkTaller || isSecondConfirmed
                  }
                  onChange={() => handleConfirm("second", item.codigo)}
                  disabled={isSecondConfirmed}
                  sx={{ color: isSecondConfirmed ? "grey" : "white" }}
                />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );

  return (
    <AppScreenBackground style={styles.backgrounOptionDos}>
      <View style={styles.container}>
        <View style={styles.row}>
          <View style={[styles.column, { flex: 1 }]}>
            <InfoComponent data={data} />
          </View>
          <View style={[styles.column, { marginLeft: 20, flex: 1 }]}>
            <ImageComponent data={data} />
          </View>
        </View>
        <View style={{ height: "50vh" }}>
          <TableComponent />
        </View>
      </View>
    </AppScreenBackground>
  );
}

const styles = StyleSheet.create({
  backgrounOptionDos: { flex: 1 },
  container: { flex: 1, padding: 10 },
  row: { flexDirection: "row", paddingVertical: 10 },
  column: { flexDirection: "column" },
});
